<script setup lang="ts">
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import { useSettingsStore } from '@/dashboard/store/settingsStore';

const settingsStore = useSettingsStore();
</script>

<template>
  <Divider class="my-xs" />

  <div class="mb-[87px] max-tablet:px-xs">
    <span
      class="text-caption-s cursor-pointer text-black underline underline-offset-[3px] dark:text-gray-500 max-tablet:mb-[22px] max-tablet:block"
      @click="() => settingsStore.toggleDeleteAccount()"
    >
      Delete my teampaper account permanently.
    </span>
    <p class="text-caption-s pl-[6px] !leading-[24.5px] text-black dark:text-gray-500">
      • Be aware that by deleting your account, all associated information and content (screenshots) will be irreversibly removed. <br />
      • Before deleting your account, you need to unsubscribe from any paid subscriptions (if you are subscribed, of course).
    </p>
  </div>
</template>

<style scoped lang="scss"></style>
